import { useMemo } from 'react';
import { CitedDocumentsList } from '@/components/shared/CitedDocumentsList';
import type { Document } from '@/hooks/useDocuments';
import {
  extractCitedDocuments,
  extractCitedWebSources,
  parseSources,
  type WebCitationDisplay,
} from '@/utils/citation-utils';

interface MessageCitedDocsProps {
  content: string;
  documents: Document[] | undefined;
  slug?: string;
  webCitationMeta?: ReadonlyMap<string, WebCitationDisplay>;
}

export const MessageCitedDocs = ({
  content,
  documents,
  slug,
  webCitationMeta,
}: MessageCitedDocsProps) => {
  const sources = useMemo(() => parseSources(content, documents), [content, documents]);
  const citedDocs = useMemo(
    () => extractCitedDocuments(content, sources, documents),
    [content, sources, documents]
  );
  const webSources = useMemo(
    () => extractCitedWebSources(content, webCitationMeta),
    [content, webCitationMeta],
  );

  if (citedDocs.size === 0 && webSources.length === 0) return null;

  return (
    <div className="mt-3">
      <CitedDocumentsList
        citedDocuments={citedDocs}
        webSources={webSources}
        documents={documents}
        compact
        slug={slug}
      />
    </div>
  );
};

export default MessageCitedDocs;
